import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';

export const SearchContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export const ResultActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
}));

export const ResultSnippet = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
    '& mark': {
        backgroundColor: theme.palette.warning.light,
        padding: '0 2px',
        borderRadius: '2px',
    },
}));

export const ResultHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

export const ResultContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
}));

export const ResultFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
}));

export const ResultPaper = styled(ShPaper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        boxShadow: theme.shadows[4],
    },
}));

export const AvatarContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    animation: 'fadeIn 0.3s ease-in-out',
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.95)',
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
})); 